import React, { useState, useEffect } from 'react';
import { Button, Form, Image, Alert, Table, ProgressBar, Badge, Modal, FormText, Accordion, Card, Row, Col, Container } from 'react-bootstrap';
import { RenderHeader } from '../_components/Header';
import { NavbarSmart } from '../_components/NavbarSmart';
import Cookies from 'universal-cookie';
import axios from 'axios';

function LinkedIn() {

  // state vars
  const [jobList, setJobList] = React.useState(null);
  const [isLoading, setIsLoading] = React.useState(false);

  async function fetchLinkedinJobs() {
    setIsLoading(true);
    const cookies = new Cookies();
    const submitItems = {
        email: cookies.get("e"),
        authToken: cookies.get("t")
    }
    await axios.post(process.env.REACT_APP_BASE_URL + 'jobs/list/jobsLinkedin', submitItems)
      .then( response => {
          setJobList(response.data)
          setIsLoading(false);
      }).catch(error => {
        console.error(error);
      });
  }

  React.useEffect(() => {
    fetchLinkedinJobs();
  }, []);

  return (
    <>
      <RenderHeader />
      <NavbarSmart showLoggedIn='true' />
      { isLoading ? <Alert>Loading...</Alert> : <></> }
      <p>LinkedIn Special Phil</p>
      <Container>
        <Row>
          <Col >
            <Table responsive="sm" striped bordered hover>
              <thead>
                <tr>
                  <th>Job Title<br/>&nbsp;</th>
                  <th>Company &<br/> Post Date</th>
                </tr>
              </thead>
              <tbody>
                
                  {jobList && jobList.map((job, i) => (
                    <tr key={i}>
                    <td>{job.postTitle}</td>
                    <td>{job.companyName}<br/>
                        <i>{job.created.substring(0,10)}</i></td>
                    </tr>
                  ))}

              </tbody>

            </Table>
          </Col>
        </Row>
      </Container>


      
    </>
  );
}

export default LinkedIn;